<template>
  <!-- begin:: Aside -->
  <div
    class="aside aside-left aside-fixed d-flex flex-column flex-row-auto gmf-aside gmf-aside-light tw-flex tw-h-full tw-flex-col"
    id="kt_aside"
    ref="kt_aside"
    :style="asideStyle"
  >
    <KTBrand></KTBrand>

    <div class="aside-menu-wrapper flex-column-fluid tw-min-h-0 tw-flex-1" id="kt_aside_menu_wrapper">
      <div
        ref="kt_aside_menu"
        id="kt_aside_menu"
        class="aside-menu tw-h-full"
        data-menu-vertical="1"
        data-menu-dropdown-timeout="500"
        v-bind:class="asideMenuClass"
      >
        <perfect-scrollbar
          id="kt_aside_menu_scroll"
          class="aside-menu scroll"
          style="max-height: calc(100vh - 96px); position: relative;"
        >
          <KTMenu></KTMenu>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
  <!-- end:: Aside -->
</template>

<script>
import { mapGetters } from "vuex";
import KTBrand from "@/view/layout/brand/Brand.vue";
import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTMenu from "@/view/layout/aside/Menu.vue";

export default {
  name: "KTAside",
  data() {
    return {};
  },
  components: {
    KTBrand,
    KTMenu
  },
  mounted() {
    this.$nextTick(() => {
      const asideRef = this.$refs["kt_aside"];
      KTLayoutAside.init(asideRef);
      asideRef.querySelectorAll("a").forEach(item => {
        item.addEventListener("click", () => {
          if (KTLayoutAside.getOffcanvas && KTLayoutAside.getOffcanvas()) {
            KTLayoutAside.getOffcanvas().hide();
          }
        });
      });
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);
    });
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),
    asideStyle() {
      return {};
    },
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  }
};
</script>

<style src="@/assets/css/tailwind.css"></style>

